import GenericPopup from '@/shared-components/popups/components/GenericPopup';

export default function PopupCertificateOfOwnership({ open, onClose }) {
  return (
    <GenericPopup open={open} opacity className="purchase-popup__coo" onClose={onClose}>
      <div style={{ padding: 20 }}>
        <h3 style={{ marginTop: 0 }}>Certificate of Ownership</h3>
        <p style={{ color: 'var(--app-grey-color)' }}>
          Suarte provides a digital Certificate of Ownership to the collector upon purchase.
        </p>
      </div>
    </GenericPopup>
  );
}